module.exports = __webpack_public_path__ + "img/rxlog.1e58300d.png";